export const splitUserName = (userName: string): Array<string> => {
  if (!userName) return [''];
  return userName.split(' ');
};
